import React, { useState } from 'react';
import './FunFact.css';

const funFacts = [
  '"吃豆人"的灵感来自一个缺少一片的披萨。',
  '"魂斗罗"的著名秘籍（上上下下左右左右BA）首次出现在1986年的红白机游戏"宇宙巡航机"中。',
  '"太空侵略者"在日本非常受欢迎，曾导致全国100日元硬币短缺。',
  '任天堂最初是一家制作花札纸牌的公司，成立于1889年。',
  'PlayStation 2是史上最畅销的游戏机，销量超过1.55亿台。',
  '"大金刚"中的马里奥最初的名字是"跳跳人"。',
  '本站在AsakaYunyu的赞助下得以免费运营',
  '感谢爱发电用户_75049为本站慷慨解囊',
  '日出东逝.月落西希。杨雄焘的赞助帮助本站无广告运营',
  '大菲的赞助在保障和维持本站运作',
  'Skyy的赞助帮助本站持续运营',
  '“李白”的赞助帮助本站持续运营',
  '仙剑奇侠传曾考虑让赵灵儿“附体复活”，但团队意见不合最终取消。',
  '任天堂曾以神游机的名义在国内发售过N64，但并未取得成功。',
  '前导软件开发的“神鹰突击队”是中国最早的商业游戏之一。',
  '“电软”最初并不是叫《电子游戏软件》，而是名为 《GAME集中营》。',
  '红白机上的魂斗罗其实是一款街机移植游戏。',
  'Tentacle的赞助帮助本站持续运营',
  '张小潇的赞助帮助本站持续运营',
  '感谢爱发电用户_e99b2为本站慷慨解囊',
  '感谢爱发电用户_d348d为本站慷慨解囊',
  '感谢freeman-C3赞助本站',
  '网页里的电脑博物馆的赞助帮助本站持续运营',
  '糖的赞助帮助本站持续运营',
  '苏提的赞助帮助本站持续运营',
  'KingDavid456的赞助帮助本站持续运营',
  '小雅的赞助帮助本站持续运营',
  '吉川优子的赞助帮助本站持续运营',
  '慕龙如雪的赞助帮助本站持续运营',
  '爱发电用户_th6D的赞助帮助本站持续运营',
  '我们网站的成立已经超过三年了!',
  '"俄罗斯方块"是第一款进入太空的游戏，1993年由宇航员带上了和平号空间站。',
  '"最终幻想"系列得名，是因为主创坂口博信把这视为他在游戏行业的"最后一搏"。',
  '"塞尔达传说"中的主角Link名字来源于"连接"（Link）玩家与游戏世界的概念。',
  '"生化危机"最初的开发代号是"Biohazard"，但在北美因商标问题改名为"Resident Evil"。',
];

const FunFact = () => {
  // Initialize with a random fun fact immediately to avoid empty state
  const [funFact] = useState(() => {
    const randomIndex = Math.floor(Math.random() * funFacts.length);
    return funFacts[randomIndex];
  });

  return (
    <div className="fun-fact-section">
      <h3 className="fun-fact-title">你知道吗？</h3>
      <p className="fun-fact-text">{funFact}</p>
    </div>
  );
};

export default FunFact;
